import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const rebates = [
  {
    program: 'Federal Tax Credit (IRA)',
    amount: 'Up to $3,200/year',
    eligible: ['Heat Pumps (up to $2,000)', 'Insulation & Air Sealing ($1,200)', 'Electrical Panel Upgrades ($600)', 'Energy-Efficient Windows ($600)'],
    color: 'border-[#C41E3A]',
    badge: 'Federal Program',
    badgeBg: 'bg-[#C41E3A]',
  },
  {
    program: 'Heat Pump Rebates (IRA §25C)',
    amount: 'Up to $2,000',
    eligible: ['Heat Pump HVAC Systems', 'Heat Pump Water Heaters ($1,750)', 'Ductless Mini-Split Systems', 'Geothermal Heat Pumps'],
    color: 'border-[#0C2340]',
    badge: 'Most Popular',
    badgeBg: 'bg-[#0C2340]',
  },
  {
    program: 'State & Utility Rebates',
    amount: 'Varies by State',
    eligible: ['HVAC Equipment Upgrade', 'Smart Thermostat Rebate ($75–$250)', 'Water Heater Efficiency', 'Home Energy Audit ($0–$500)'],
    color: 'border-[#E2E8F0]',
    badge: 'Ask Your Advisor',
    badgeBg: 'bg-[#6B7280]',
  },
];

const RebatesPage = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <section className="bg-[#0C2340] py-20 nav-offset">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-[#C41E3A] text-sm font-bold uppercase tracking-widest mb-3">Rebates &amp; Incentives</p>
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-5">Save Thousands on Upgrades</h1>
          <p className="text-xl text-white/75 max-w-2xl mx-auto">Federal, state, and utility rebates can cover a significant portion of your home improvement costs. Renova helps you navigate every available incentive.</p>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-14">
            <h2 className="text-3xl md:text-4xl font-bold text-[#111827] mb-4">Available Rebate Programs</h2>
            <p className="text-[#6B7280] max-w-2xl mx-auto">We handle the paperwork for all qualifying rebate programs. You focus on comfort, we focus on savings.</p>
          </div>

          <div className="grid md:grid-cols-3 gap-6 mb-16">
            {rebates.map((r) => (
              <div key={r.program} className={`relative rounded-2xl border-2 ${r.color} p-8`}>
                <div className={`absolute -top-3 left-6 px-4 py-1 rounded-full text-xs font-bold text-white ${r.badgeBg}`}>{r.badge}</div>
                <h3 className="text-xl font-bold text-[#111827] mb-2 mt-2">{r.program}</h3>
                <p className="text-2xl font-bold text-[#C41E3A] mb-6">{r.amount}</p>
                <ul className="space-y-2">
                  {r.eligible.map((e) => (
                    <li key={e} className="flex items-start space-x-2 text-sm text-[#374151]">
                      <i className="ri-check-line text-[#C41E3A] mt-0.5" />
                      <span>{e}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="bg-[#F8F9FB] rounded-2xl p-10 text-center border border-[#E2E8F0]">
            <h2 className="text-3xl font-bold text-[#111827] mb-4">How Renova Handles Rebates</h2>
            <p className="text-[#6B7280] mb-8 max-w-2xl mx-auto">Our advisors identify every applicable rebate before your project starts. We submit documentation, track approvals, and ensure you receive every dollar you&apos;re entitled to.</p>
            <div className="grid md:grid-cols-4 gap-6 mb-8">
              {[
                { num: '1', title: 'Free Assessment', desc: 'We audit your home and identify qualifying upgrades.' },
                { num: '2', title: 'Rebate Planning', desc: 'We calculate total available federal, state, and utility rebates.' },
                { num: '3', title: 'Installation', desc: 'Certified installation with all required documentation captured.' },
                { num: '4', title: 'Rebate Filing', desc: 'We handle paperwork and filing for all qualifying programs.' },
              ].map((s) => (
                <div key={s.num} className="text-center">
                  <div className="w-12 h-12 bg-[#C41E3A] rounded-full flex items-center justify-center mx-auto mb-3">
                    <span className="text-white font-bold">{s.num}</span>
                  </div>
                  <h4 className="text-sm font-bold text-[#111827] mb-2">{s.title}</h4>
                  <p className="text-xs text-[#6B7280]">{s.desc}</p>
                </div>
              ))}
            </div>
            <button onClick={() => navigate('/book-appointment')} className="bg-[#C41E3A] text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-[#A01830] transition-colors whitespace-nowrap cursor-pointer">
              Get Your Free Rebate Assessment
            </button>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default RebatesPage;
